module.exports = __webpack_public_path__ + "img/ring_g_e_1_1@2x.8a4407e5.png";